module.exports = {
  siteTitle: 'Dylan Zhu',
  siteDescription:
    'Dylan Zhu is an incoming Software Developer, who loves learning new things and helping tech beginners. He is an experienced FullStack & Blockchain developer',
  siteKeywords:
    'Dylan Zhu, Dylan, Zhu, software engineer, web developer, javascript, python, react, node, express, nft, smart contract, solidity, blockchain, nextjs',
  siteUrl: 'https://dylanzhu.netlify.app/',
  siteLanguage: 'en_US',
  googleAnalyticsID: 'UA-45666519-2',
  googleVerification: 'DCl7VAf9tcz6eD9gb67NfkNnJ1PKRNcg8qQiwpbx9Lk',
  name: 'Dylan Zhu',
  location: 'Singapore',
  email: 'pauleta0126@gmail.com',
  github: 'https://github.com/jusdy',
  twitterHandle: '@',
  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/jusdy',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/dylan-zhu/',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,

  colors: {
    green: '#66ffdf',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
